import validate from 'jquery-validation';
import mask from 'jquery-mask-plugin';

export default function sendForm(){
	$('[name="phone"]').mask('(00) 00000-0000');
	const selectform = $('[data-formvalidate]');
	if (selectform.length) {
		selectform.each(function(index, el) {
			const message = $(el).data('message');
			$(this).validate({
				errorPlacement: function(error, element) {
					if (message) {
						element.after(error);
					}
					return false;
				},
				messages: {
					name: {
						required: "Campo nome é obrigatório"
					},
					email: {
						required : "Campo e-mail é obrigatório",
						email : "Por favor insira um e-mail válido"
					},
					message: {
						required : "Campo descrição é obrigatório"
					}
				},
				submitHandler: function(form) {
					grecaptcha.ready(() => {
						grecaptcha.execute(document.getElementById("recaptcha").value, {
							action: 'submit'
						}).then(token => {
							var data;
							var contentType = "application/x-www-form-urlencoded";
							var processData = true;
		
							// Captura o valor do reCAPTCHA
		
							if ($(form).attr('enctype') === 'multipart/form-data') {
								data = new FormData($('.form-file').get(0));
								data.append('gRecaptchaResponse', token);
								contentType = false;
								processData = false;
							} else {
								data = $(form).serialize() + '&gRecaptchaResponse=' + encodeURIComponent(token);
							}
		
							$.ajax({
								data: data,
								type: $(form).attr('method'),
								url: $(form).attr('action'),
								dataType: 'json',
								contentType: contentType,
								processData: processData,
								success: function(response) {
									var data;
									try {
										data = typeof response === "object" ? response : JSON.parse(response);
									} catch (e) {
										data = { status: "error", message: "Resposta inesperada do servidor." };
									}
		
									if (data.status === false) {
										Swal.fire({
											icon: 'warning',
											title: "Ops!",
											text: data.message
										});
									} else {
										Swal.fire({
											icon: 'success',
											title: "Muito Obrigado!",
											text: data.message
										});
										form.reset();
									}
								},
								error: function() {
									Swal.fire({
										icon: 'warning',
										title: "Oops, algo deu errado!",
										text: "Não foi possível enviar sua mensagem."
									});
									form.reset();
								}
							});
						});
					});
				}

			});
		});
	}
}